// extracted by mini-css-extract-plugin
module.exports = {"btn-menu":"_3BV4fHadMTPbNDaJEMnQO1"};